import $ from 'jquery'

class OverlapStrips {
  constructor(element) {
    if (!element) return

    this.element = element
    this.wrap = jQuery(element)
 

    this.inivars()

    $(window).on('scroll', (_) => {
      this.updateStripPosition()
    })

    this.updateStripPosition()
  }

  inivars() {
    this.strips = this.wrap.find('.s-overlap-strips__strip')
    this.viewportHeight =  $(window).height();
  }

  updateStripPosition() {
   
    this.strips.each(function() {
      const $strip = $(this);
      const $sectionInner = $strip.find('.s-overlap-strips__conts');
      const contentHeight = $sectionInner.outerHeight();

      // console.log('contentHeight',  contentHeight)
      // console.log('viewport',    this.viewportHeight)

      if (contentHeight >  $(window).height()) {
          $strip.css('position', 'relative');
      } else {
          $strip.css('position', 'sticky');
      }
  });

  }
}

export default OverlapStrips
